/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import parse from 'html-react-parser';
import dollar from '../../../static/images/dollarBill-159x256.png';

export default function Content() {
  const data = useSelector((state) => state.data.data);

  const maleRef = useRef();
  const femaleRef = useRef();
  const dollarRef = useRef();

  const [sex, setSex] = useState('');
  const [ageGroup, setAgeGroup] = useState('');
  const [textField, setTextField] = useState('');
  const [textDollar, setTextDollar] = useState('');

  const selectData =
    data && data.male && data.male.length > 0
      ? data.male.map((obj) => {
          return {
            label: obj.group,
            value: obj.group,
          };
        })
      : [];

  useEffect(() => {
    if (sex !== '' && ageGroup !== '') {
      const datum = data[sex].find((obj) => {
        return obj.group === ageGroup;
      });
      const str =
        sex === 'male'
          ? `Men in Australia, aged <strong>${ageGroup}</strong>, have an average superannuation balance of`
          : `Women in Australia, aged <strong>${ageGroup}</strong>, have an average superannuation balance of`;
      setTextField(parse(str));
      setTextDollar(`$${datum.value.toLocaleString()}`);

      dollarRef.current.style.display = 'none';
    } else {
      dollarRef.current.style.display = 'block';
    }
  }, [sex, ageGroup]);

  function changeCheck(type) {
    if (type === 'male') {
      maleRef.current.checked = true;
      femaleRef.current.checked = false;
      setSex('male');
    }
    if (type === 'female') {
      maleRef.current.checked = false;
      femaleRef.current.checked = true;
      setSex('female');
    }
  }

  function handleSelectChange(selected) {
    setAgeGroup(selected.label);
  }

  return (
    <section>
      <div className="inner-wrap">
        <h1>How does my super compare?</h1>
        <p>Select your gender</p>
        <div className="checkbox-wrap">
          <div className="check-single">
            <input
              type="checkbox"
              className="css-checkbox"
              ref={maleRef}
              value="male"
              onChange={() => {
                changeCheck('male');
              }}
            />
            <label htmlFor="vehicle1">Male</label>
          </div>
          <div className="check-single">
            <input
              type="checkbox"
              className="css-checkbox"
              ref={femaleRef}
              value="female"
              onChange={() => {
                changeCheck('female');
              }}
            />
            <label htmlFor="vehicle2">Female</label>
          </div>
        </div>
        <p>Select your age</p>
        <div className="select-wrap">
          <Select
            className="react-select-container"
            classNamePrefix="rs"
            defaultValue={ageGroup}
            onChange={handleSelectChange}
            options={selectData}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                background: 'transparent',
                borderColor: state.isFocused ? '#2c58d6' : 'black',
                borderWidth: '2px',
                color: 'black',
                borderRadius: '10px',
                '&:hover': {
                  border: '2px solid #2c58d6',
                },
              }),
            }}
          />
        </div>
        <div className="bottom-section">
          <div className="dollar-holder">
            <img
              ref={dollarRef}
              src={dollar}
              width="159"
              height="256"
              alt="dollar icon"
            />
          </div>
          <div className="end-text-wrap">
            <div className="end-text">{textField}</div>
            <div className="end-text-dollar">{textDollar}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
